import { spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 64,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  '& img': {
    width: '50%',
    maxWidth: 192,
    height: 'auto',
  },

  '& .MuiTypography-body1': {
    fontSize: 16,
    lineHeight: '24px',
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    color: spaceCadet[800],
    '& svg': {
      display: 'block',
    },
  },
});

export default StyledBox;
